import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const links = [
  { label: "Collection", href: "#collection" },
  { label: "Heritage", href: "#heritage" },
  { label: "Story", href: "#story" },
  { label: "Waitlist", href: "#waitlist" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/50 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
          aria-label="Kim Monroe LLC home"
        >
          <img
            src="/logo-wordmark.png"
            alt="Kim Monroe LLC"
            className="h-10 sm:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-body text-[#A39791] hover:text-[#FDFBF7] tracking-wide transition-colors duration-500"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#waitlist"
          data-testid="nav-cta-join"
          className="hidden md:inline-block btn-gold px-6 py-3 text-xs uppercase tracking-[0.2em]"
        >
          Join Waitlist
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#FDFBF7] p-2"
        >
          {open ? <X size={24} weight="thin" /> : <List size={24} weight="thin" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-black/90 backdrop-blur-2xl border-t border-white/10"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-sm font-body text-[#A39791] hover:text-[#FDFBF7] tracking-wide"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#waitlist"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-join"
              className="btn-gold px-6 py-3 text-xs uppercase tracking-[0.2em] text-center mt-2"
            >
              Join Waitlist
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
